//import { InputGroups } from 'store/registration/types'

// ENUMS

export enum CodeTypes {
  PROMO = 'Promo',
  REFERRAL = 'Referral'
}

// REQUEST / RESPONSE TYPES

export type CheckPromoReferralCodeResponse = {
  valid: boolean
  type?: CodeTypes
  promoCode?: PromoCode
  referralCode?: ReferralCode
}

export type GetReferralCodeResponse = {
  found: boolean
  referralCode?: string
}

// DATA TYPES

export type PromoCode = {
  code: string
  refs: {
    resEL: string
    resNG: string
    proEL: string
    proNG: string
  }
  translations: {
    nl: string
    fr: string
  }
}

export type ReferralCode = {
  code: string
  referrer: {
    id: string // SF Contact id
    firstName: string // SF Contact first name
    lastName: string // SF Contact last name
  }
}
